<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>综合报告列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.id" auto-complete="off" placeholder="输入报告id"></el-input>
      </el-form-item>
      <el-form-item prop="search" v-if="isSuper">
        <el-input size="small" v-model="formInline.appId" auto-complete="off" placeholder="输入appId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.extId" auto-complete="off" placeholder="输入extId"></el-input>
      </el-form-item>
      <el-form-item prop="search">
        <el-input size="small" v-model="formInline.name" auto-complete="off" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="combination.id" label="ID"></el-table-column>
      <el-table-column prop="appId" label="应用ID"></el-table-column>
      <el-table-column prop="extId" label="用户ID"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="physiqueResultId" label="体质报告"></el-table-column>
      <el-table-column prop="tongueResultId" label="舌象报告"></el-table-column>
      <el-table-column prop="meridianResultId" label="经络报告"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-search" @click="editBusiness(scope.$index, scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog title="查看综合报告明细" :visible.sync="bfVisible" width="50%" @click="closeBfDialog">
      <div>
        <div style="margin-bottom:20px;">
          <p><strong>综合报告ID：</strong>{{result.combination.id}}</p>
          <p><strong>姓名：</strong>{{result.name}}</p>
          <p><strong>应用ID：</strong>{{result.appId}}</p>
          <p><strong>用户ID：</strong>{{result.extId}}</p>
        </div>
        <hr>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">体质结果({{result.physique.id}})</h3>
          <p><strong>体质类型：</strong>{{result.physique.resultTitle}}</p>
          <p><strong>定义：</strong>{{result.physique.definition}}</p>
          <p><strong>起因：</strong>{{result.physique.caution}}</p>
        </div>
        <hr>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">舌象结果({{result.tongue.id}})</h3>
          <p><strong>症候：</strong>{{result.tongue.diagnose.zhengHou}}</p>
          <p><strong>舌象切割图：</strong>{{result.tongue.image}}</p>
        </div>
        <hr>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">经络结果({{result.meridian.id}})</h3>
          <p><strong>体能状态值：</strong>{{result.meridian.energy}}</p>
          <p><strong>H2：</strong>{{result.meridian.H2}}</p>
          <p><strong>L2：</strong>{{result.meridian.L2}}</p>
          <p><strong>问题经络：</strong>{{result.meridian['summary'].prbMrds}}</p>
          <p><strong>症状：</strong>{{result.meridian['summary'].symptoms}}</p>
          <p><strong>经络值：</strong>{{result.meridian.viscera}}</p>
        </div>
        <hr>
        <div style="margin-bottom:20px;">
          <h3 style="text-align: center">综合结果</h3>
          <p><strong>结果代号：</strong>{{result.combination.code}}</p>
          <p><strong>调理建议：</strong>{{result.combination.advice}}</p>
          <p><strong>得分：</strong>{{result.combination.score}}</p>
          <p><strong>分数解释：</strong>{{result.combination.explain}}</p>
          <p><strong>诊断说明：</strong>{{result.combination.diagnose}}</p>
        </div>
        <hr>
        <div style="margin-bottom:20px;" v-if="result.xuewei && result.xuewei.length > 0">
          <h3 style="text-align: center">三伏天穴位调理建议</h3>
          <div v-for="s in result.xuewei">
            <p>【{{s.type}}-{{s.priority}}】<strong>穴位：</strong>{{s.position}} /  <strong>手法：</strong>{{s.method}} /  <strong>功效：</strong>{{s.effect}}</p>
          </div>

        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBfDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    loadUser, loadCombination
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  import {getStore} from "../../utils/util";

  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        bfVisible: false,
        isSuper:parseInt(getStore('isSuper')),
        title: '添加',
        editForm: {
          deptId: ''
        },
        result:{
          meridian:{
            summary:'',
            prbMrds:''
          },
          physique:{},
          tongue:{
            diagnose:{

            }
          },
          combination:{
            code:''
          },
          xuewei:[]
        },
        businessForm: {},
        formInline: {
          pageNum: 1,
          pageSize: 10,
          appId:'',
          extId:'',
          name:''
        },

        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        list: []

      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      stateTrans(row, column, cellValue, index) {
        return cellValue == 1 ? '正常' : '禁用';
      },

      getdata(parameter) {
        this.loading = true
        loadCombination(parameter)
          .then(res => {
            this.loading = false
            if (res.code !== '0000') {
              this.$message({
                type: 'error',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNum
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },

      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNum = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },

      //显示编辑界面
      handleEdit: function (index, row) {
        window.open(row.reportUrl)
      },
      handleSearch: function(index, row){
        this.formInline.pageNum = 1
        this.getdata(this.formInline)
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      },
      closeBfDialog() {
        this.bfVisible = false;
      },
      editBusiness(index, row) {
        this.bfVisible = true;
        this.result = row
      },
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/combination/list.vue